import { useEffect, useState } from "react";
import { MapPin, ArrowUpRight } from "lucide-react";
import { hasExternalContentConsent, openCookiePreferences, startConsentWatcher } from "@/lib/iubenda";
import { CONTACT } from "@/lib/site";

const MAP_SRC = "https://www.google.com/maps?q=Via%20Giuseppe%20Bonito%2019%2C%20Napoli&output=embed";
// Direct link to Google Maps: works always, even without cookie consent
// (a plain external link does not set any third-party cookie on our site).
export const MAP_LINK = CONTACT.mapsUrl;

// Google Maps embed loaded only after the user grants consent (GDPR compliant)
const MapEmbed = () => {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    startConsentWatcher();
    setAllowed(hasExternalContentConsent());
    const onChange = () => setAllowed(hasExternalContentConsent());
    window.addEventListener("ms-consent-change", onChange);
    return () => window.removeEventListener("ms-consent-change", onChange);
  }, []);

  return (
    <div className="mt-10 overflow-hidden rounded-2xl border border-[#E7EDF2] shadow-sm" data-testid="contact-map">
      {allowed ? (
        <>
          <iframe
            title="Mappa Medisistem"
            src={MAP_SRC}
            width="100%"
            height="300"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          <div className="flex flex-wrap items-center justify-between gap-2 border-t border-[#E7EDF2] bg-white px-4 py-3">
            <span className="text-sm text-muted-foreground">Via Giuseppe Bonito 19, Napoli</span>
            <a href={MAP_LINK} target="_blank" rel="noopener noreferrer" data-testid="map-external-link" className="inline-flex items-center gap-1.5 text-sm font-semibold text-green-deep transition-colors hover:text-green">
              Apri in Google Maps <ArrowUpRight size={14} />
            </a>
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center justify-center gap-4 bg-cloud px-6 py-12 text-center" style={{ minHeight: 300 }} data-testid="map-consent-placeholder">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-green/12 text-green-deep"><MapPin size={22} /></span>
          <div>
            <p className="font-semibold text-navy">Mappa disattivata</p>
            <p className="mt-1 text-sm text-muted-foreground max-w-sm">Per visualizzare la mappa è necessario accettare i cookie relativi ai contenuti esterni. In alternativa puoi aprire la posizione direttamente su Google Maps.</p>
          </div>
          <div className="flex flex-col items-center gap-3 sm:flex-row">
            <button onClick={openCookiePreferences} data-testid="map-consent-accept" className="btn-green">Gestisci preferenze cookie</button>
            <a href={MAP_LINK} target="_blank" rel="noopener noreferrer" data-testid="map-external-link" className="inline-flex items-center gap-1.5 text-sm font-semibold text-green-deep underline underline-offset-4 transition-colors hover:text-green">
              Apri in Google Maps <ArrowUpRight size={14} />
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapEmbed;
